import styled from '@emotion/styled'

import cx from 'classnames'

import { Carousel, type CarouselButtonsProps } from '@/legacy/components/Carousel'
import {
  getCarouselController,
  type CarouselControllers,
} from '@/legacy/components/Carousel/CarouselButtons/utils'
import { MediaContainer, type MediaContainerProps } from '@/legacy/components/MediaContainer'
import { clearBuilderProps } from '@/legacy/core/utils/dom/clearBuilderProps'
import { CONFIG } from '@/ui/shared/styles'

import { MediaCategoryItem, type MediaCategoryItemProps } from './MediaCategoryItem'

export interface MediaCategoryBlockProps extends MediaContainerProps {
  items: MediaCategoryItemProps[]
  carouselController?: CarouselControllers
  carouselControllerColor?: CarouselButtonsProps['colorModifier']
}

const MediaCategoryBlockStyles = styled.div`
  .c-list {
    min-height: 16.5rem;
  }

  ${CONFIG.media.mobileLg} {
    .c-list {
      min-height: 31.5rem;
    }
  }
  @media (min-width: ${CONFIG.maxWidths.lg}) {
    .media-container--full-size .carousel-floating-controller .carousel-legend {
      max-width: none;
      position: absolute;
      bottom: 1rem;
      left: 40%;
    }

    .c-list--floating {
      max-width: calc(100% - 10.5rem);
    }
    .media-container {
      position: relative;
    }
  }
`

const MediaCategoryBlock = ({
  items,
  carouselController,
  carouselControllerColor,
  ...mediaContainerProps
}: MediaCategoryBlockProps) => {
  clearBuilderProps(mediaContainerProps)
  const selectedCarouselController = getCarouselController(carouselController)
  const isFloatingCarousel = carouselController === 'floating'
  const hasAnyItemWithFullSizeImage = items?.some((item) => item.midia.imageSize === 'xg')

  return (
    <MediaCategoryBlockStyles>
      <MediaContainer
        className={cx('media-container', {
          'media-container--full-size': hasAnyItemWithFullSizeImage,
        })}
        {...mediaContainerProps}
      >
        {items && items.length > 1 && (
          <Carousel
            renderButtons={selectedCarouselController}
            itemGap={0}
            visibleCountDesktop={1}
            visibleCountMobile={1}
            className="c-list"
            buttonColorModifier={carouselControllerColor}
          >
            {items.map((item, index) => (
              <MediaCategoryItem
                className={cx({ 'c-list--floating': isFloatingCarousel })}
                key={`mc_item_${index}`}
                {...item}
              />
            ))}
          </Carousel>
        )}
        {items && items.length === 1 && <MediaCategoryItem {...items[0]} />}
      </MediaContainer>
    </MediaCategoryBlockStyles>
  )
}

export default MediaCategoryBlock
